import { cn } from "@/utils/cn";

/**
 * The app's icon mark — 4 rounded chips in the same 4 skill colors used
 * everywhere else in the product (mock-type tabs, exam cards, dashboard
 * strength bars: see globals.css `--skill-*`). Deliberately NOT a letter
 * monogram — the project's name/domain is expected to change, and a mark
 * built from the product's own skill palette stays meaningful regardless
 * of what the site ends up being called.
 *
 * Inlined as SVG (not an <img src="/logo-mark.svg">) so it's crisp at any
 * size with no extra request; `public/logo-mark.svg` holds the same
 * artwork as a standalone file for use outside the app (favicon source,
 * external brand asset).
 */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" fill="none" aria-hidden="true" className={cn("h-7 w-7", className)}>
      <rect x="0" y="0" width="14" height="14" rx="4" fill="var(--skill-listening)" />
      <rect x="18" y="0" width="14" height="14" rx="4" fill="var(--skill-reading)" />
      <rect x="0" y="18" width="14" height="14" rx="4" fill="var(--skill-speaking)" />
      <rect x="18" y="18" width="14" height="14" rx="4" fill="var(--skill-writing)" />
    </svg>
  );
}
